export default __webpack_public_path__ + "static/media/logo138x75white.2adc3c08.png";